import React from 'react';
import { RevoltButton } from '../../../../../components';

/**
 * ModelCard Component
 * Displays individual AI model information in card format
 */
function ModelCard({ model, onCardClick, onOpenContextMenu }) {
  // Tinting uses the same CSS variable approach as app cards.
  const modelColor = model?.color || null;
  const cardTintStyle = modelColor
    ? {
        '--model-color-r': parseInt(modelColor.slice(1, 3), 16),
        '--model-color-g': parseInt(modelColor.slice(3, 5), 16),
        '--model-color-b': parseInt(modelColor.slice(5, 7), 16),
        '--model-color-alpha':
          modelColor.length === 9 ? parseInt(modelColor.slice(7, 9), 16) / 255 : 0.15,
      }
    : {};

  const handleCardClick = () => {
    onCardClick(model);
  };

  const handleContextMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onOpenContextMenu?.(model, e);
  };

  const handleSettingsClick = (e) => {
    e.stopPropagation();
    onCardClick(model);
  };

  // Format date and time nicely
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div
      className={`model-card grid-card ${model.fileMissing ? 'missing-file' : model.isActive ? 'active' : 'inactive'}`}
      style={cardTintStyle}
      onClick={handleCardClick}
      onContextMenu={handleContextMenu}
    >
      {/* Row 1: Title and Status */}
      <div className="model-card-header">
        <h3 className="model-card-title">
          {model.displayName}
        </h3>
        <span className={`model-card-status ${model.fileMissing ? 'missing-file' : model.isActive ? 'active' : 'inactive'}`}>
          {model.fileMissing ? 'Missing file' : model.isActive ? 'Active' : 'Inactive'}
        </span>
      </div>

      {/* Row 2: Date Modified and Settings Button */}
      <div className="model-card-meta-row">
        <span className="model-card-date">
          Modified: {formatDateTime(model.updatedAt)}
        </span>
        <RevoltButton
          variant="ghost"
          size="sm"
          onClick={handleSettingsClick}
          title="Model settings"
        >
          <i className="fa-solid fa-gear"></i>
        </RevoltButton>
      </div>
    </div>
  );
}

export default ModelCard;